<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-billing_address_city`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BillingCity",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('billing_address.city')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'billing_address.city',
      defaultLabel: this.$t("City")
    }
  }
}
</script>

<style scoped>

</style>
